import { proxy } from 'valtio';

export interface ZoningFeature {
  z: string;
  zone_name: string;
  zone_type: string;
  zone_code: string;
  fill_color: string;
  point: {
    lng: number;
    lat: number;
  };
}

class Store {
  highlightedZoneCode: string | null = null;
  zonesInView: { [key: string]: ZoningFeature } = {};
  mapZoom: number = 14;

  updateHighlightedZoneCode(zoneCode: string | null) {
    this.highlightedZoneCode = zoneCode;
  }

  updateMapZoom(zoom: number) {
    this.mapZoom = zoom;
  }
}

const store = proxy(new Store());

export default store;
